export default __webpack_public_path__ + "static/media/KOD0065-min.d3c5f261.webp";